import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Message from "../../components/Message";
import { formatDate, formatTime } from "../../utils/formatDate";

type PropsType = {
  closeDate: string;
  timeZone: string;
  registrationRequired: boolean;
};

const Wrapper = styled.div`
  margin: var(--space-150) 0 0 0;
`;

const LastRegistrationDate = ({
  closeDate,
  timeZone,
  registrationRequired,
}: PropsType) => {
  const { t } = useTranslation();

  const registrationClosedDate = `${formatDate(closeDate)} ${formatTime(
    closeDate,
    timeZone
  )}`;

  const now = new Date();
  const inThefuture = new Date(now.getTime() + 24 * 60 * 60 * 1000);
  const closeDateDate = new Date(closeDate);

  if (
    !closeDate ||
    !registrationRequired ||
    closeDateDate < now ||
    closeDateDate > inThefuture
  ) {
    return null;
  }

  return (
    <Wrapper>
      <Message subtle>
        {t("event.lastDate", { closeDate: registrationClosedDate })}
      </Message>
    </Wrapper>
  );
};

export default LastRegistrationDate;
